import { render, staticRenderFns } from "./IssueTrackingMgmt.vue?vue&type=template&id=47eb6fce"
import script from "./IssueTrackingMgmt.vue?vue&type=script&lang=js"
export * from "./IssueTrackingMgmt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports